const toastMessages = {
  genericErrorHeading: "Oops, something went wrong!",
  genericErrorDescription: "An error occurred. Please try again later.",
  requestTimeoutHeading: "Slow network is detected",
  requestTimeoutDescription: "Please try again later",
  genericSuccessMessage: "Action successful",
};

export default toastMessages;